export const WORKFLOWS = 'workflows';

export type WorkflowsState = {
  showNodesType: boolean;
  clickedPlusNodeId: string | null;
  selectedTrigger: {
    id: number;
    name: string;
    model?: string;
  } | null;
  nodeConfigurations: Record<string, NodeConfiguration>;
};

export type NodeConfiguration = {
  nodeId: string;
  nodeType: 'trigger' | 'condition' | 'action';
  data: TriggerData | ConditionData | ActionData;
};

export type TriggerData = {
  triggerId: number;
  name: string;
};

export type SingleCondition = {
  attribute: string;
  condition: string;
  value: string;
  valueType: string;
};

export type ConditionGroupData = {
  operator: 'and' | 'or';
  conditions: SingleCondition[];
  subgroups: ConditionGroupData[];
};

export type ConditionData = ConditionGroupData;

export type ActionData = {
  actionType: string;
  title: string;
  returnValue: string;
  content?: string;
  message?: string;
  topic?: string;
  sectionId?: string;
  selectedProductId?: number;
  unit?: string;
  amount?: number;
  partnerId?: number;
  partnerName?: string;
  recipient?: string;
};
